import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/app/layouts/blank.vue").then(m => m.default || m)),
  "default-max-screen": defineAsyncComponent(() => import("/app/layouts/default-max-screen.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  partner: defineAsyncComponent(() => import("/app/layouts/partner.vue").then(m => m.default || m))
}